export default __webpack_public_path__ + "static/media/logo-row-dark.9e67bcf2.svg";